module.exports = __webpack_public_path__ + "static/media/apply-mobile.35e5bf02.png";